var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeisure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#B30053"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.948 12.4122L16.8297 12.2939C16.272 11.7561 15.5866 11.3693 14.838 11.1697C12.4155 10.5214 10.0889 11.8939 9.42803 14.3614C9.3922 14.4947 9.37303 14.6447 9.34137 15.0205C9.21303 16.5789 8.84637 17.7414 7.84137 18.9205C9.7247 19.6605 11.9564 20.1822 13.653 20.1822C14.6616 20.181 15.6416 19.8474 16.4415 19.2331C17.2414 18.6188 17.8166 17.758 18.078 16.7839C18.2833 16.0196 18.2871 15.2153 18.0891 14.4491C17.8911 13.683 17.4979 12.9812 16.948 12.4122ZM15.143 9.52721L19.2589 6.32637C19.4191 6.20189 19.6193 6.14015 19.8218 6.15273C20.0243 6.16531 20.2153 6.25135 20.3589 6.3947L22.8547 8.88971C22.9983 9.03335 23.0845 9.22449 23.097 9.4272C23.1096 9.62991 23.0477 9.83024 22.923 9.99054L19.723 14.1055C19.9487 15.0259 19.9622 15.9854 19.7627 16.9118C19.5631 17.8381 19.1557 18.707 18.5711 19.4528C17.9866 20.1986 17.2402 20.8018 16.3883 21.2169C15.5365 21.632 14.6015 21.8481 13.6539 21.8489C10.7347 21.8489 6.9847 20.5972 4.90137 19.3472C8.21803 16.8472 7.44053 15.3389 7.81803 13.9305C8.6997 10.6389 11.853 8.71637 15.1422 9.52721H15.143ZM17.9872 11.093C18.0414 11.1455 18.0955 11.1997 18.148 11.2547L19.0939 12.1997L21.1564 9.54804L19.7014 8.09304L17.0497 10.1555L17.9872 11.093Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeisure);
export default __webpack_public_path__ + "static/media/Leisure.3072c2e5cc2a8ccfb418ea2dfd3922f4.svg";
export { ForwardRef as ReactComponent };